import { Box, Button, Card, Modal, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import SearchInput from "../SearchInput";
import { icons } from "../../assets/icons/icons";
import { colors } from "../../values/colors";
import NoDataView from "../NoDataView";

const SoldModal = ({
  open,
  onClose,
  onConfirm,
  teams,
  teamDetail,
  selectTeam,
  setSelectTeam,
  playerCounts,
  currBid,
  totalPlayerCount,
  baseBid,
}) => {
  const [search, setSearch] = useState("");
  const [teamData, setTeamData] = useState(teams);

  const checkPoints = (teamPlayerCount, availablePoints) => {
    if (teamPlayerCount == null) return true;
    const remainingPlayer = totalPlayerCount - teamPlayerCount;
    const needPointsToBuy = remainingPlayer * baseBid;
    return availablePoints >= needPointsToBuy;
  };

  useEffect(() => {
    const safeSearch = (search || "").trim().toLowerCase();

    if (safeSearch.length === 0) {
      setTeamData(teams); // `teams` = full original list
      return;
    }

    const filteredTeams = teamDetail.filter((ele) =>
      ele?.teamName?.toLowerCase().includes(safeSearch)
    );

    const lookup = new Map(filteredTeams.map((t) => [t._id, t]));

    const teamsMap = teams
      .map((item) => {
        const detail = lookup.get(item.teamId);
        return detail ? { ...item } : null;
      })
      .filter(Boolean);

    setTeamData(teamsMap);
  }, [search, teams, teamDetail]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Card
        sx={{
          width: 400,
          borderRadius: "16px",
          boxShadow: "0px 4px 25px rgba(0,0,0,0.15)",
        }}
      >
        <Box sx={{ p: 2, borderBottom: "1px solid #E8ECF4" }}>
          <Typography sx={{ fontWeight: "600", fontSize: "1.2rem" }}>
            Sold To
          </Typography>
        </Box>
        <Box sx={{ p: 2 }}>
          <SearchInput
            placeholder="Search teams"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </Box>
        <Box sx={{ p: 2 }}>
          <Typography sx={{ fontWeight: "600", fontSize: "1.2rem" }}>
            Select Team
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "1rem",
              maxHeight: "24rem",
              overflowY: "scroll",
            }}
          >
            {teamData?.length === 0 && <NoDataView text="No teams found" />}
            {teamData?.map((items) => {
              return (
                <Box
                  key={items?._id}
                  sx={{
                    boxShadow:
                      "0px 19.15px 19.15px 0px rgba(126, 126, 126, 0.11)",
                    p: 2,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    position: "relative",
                  }}
                  onClick={() => {
                    if (
                      playerCounts[items?.teamId] >= totalPlayerCount ||
                      currBid > items?.currentPoints
                      // !checkPoints(
                      //   playerCounts[items?.teamId],
                      //   items?.currentPoints
                      // )
                    )
                      return;
                    setSelectTeam(items);
                  }}
                >
                  {playerCounts[items?.teamId] >= totalPlayerCount ? (
                    <Typography
                      sx={{
                        position: "absolute",
                        color: "#FF0140",
                        top: 4,
                        right: 4,
                        fontSize: ".9rem",
                      }}
                    >
                      Max Players Purchased
                    </Typography>
                  ) : currBid > items?.currentPoints ? (
                    // !checkPoints(
                    //   playerCounts[items?.teamId],
                    //   items?.currentPoints
                    <Typography
                      sx={{
                        position: "absolute",
                        color: "#FF0140",
                        top: 4,
                        right: 4,
                        fontSize: ".9rem",
                      }}
                    >
                      Not Enough Points
                    </Typography>
                  ) : (
                    <></>
                  )}
                  <Box>
                    {}
                    <Typography sx={{ fontWeight: "600", fontSize: "1.2rem" }}>
                      {
                        teamDetail?.filter(
                          (ele) => items?.teamId === ele?._id
                        )[0]?.teamName
                      }
                    </Typography>
                    <Typography>
                      Available Points: {items?.currentPoints}
                    </Typography>
                    <Typography>
                      Players Purchased: {playerCounts[items?.teamId] ?? 0}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      width: "2.5rem",
                      height: "2.5rem",
                      display:
                        items?.teamId === selectTeam?.teamId ? "block" : "none",
                    }}
                  >
                    <img
                      src={icons.greentick}
                      alt="tick"
                      width={"100%"}
                      height={"100%"}
                    />
                  </Box>
                </Box>
              );
            })}
          </Box>
          <Box
            sx={{
              mt: 3,
              display: "flex",
              justifyContent: "space-around",
            }}
          >
            <Button
              variant="contained"
              onClick={onClose}
              sx={{
                backgroundColor: "#1E1E1E",
                color: "#fff",
                textTransform: "none",
                borderRadius: "999px",
                py: ".5rem",
                fontSize: "1rem",
                width: "120px",
                "&:hover": { backgroundColor: "#000" },
              }}
            >
              Close
            </Button>
            <Button
              variant="contained"
              onClick={onConfirm}
              sx={{
                background: colors.linearGradent,
                color: "#fff",
                textTransform: "none",
                borderRadius: "999px",
                width: "120px",
              }}
            >
              Confirm
            </Button>
          </Box>
        </Box>
      </Card>
    </Modal>
  );
};

export default SoldModal;
